import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from "react";
import { observer } from "mobx-react-lite";
import { SidebarContent } from "./SidebarContent";
import { UIStateStoreContext } from "../../stores/uiStateStore";
import "./sidebar.css";
/**
 * Renders the custom sidebar. Custom sidebar was needed in order to include custom icons for the mobile view.
 */
export const CustomSidebar = observer(() => {
    const state = useContext(UIStateStoreContext);
    return (_jsx("div", { className: `sui-layout-sidebar${state.isSidebarToggled() ? " sui-layout-sidebar--toggled" : ""}`, "data-testid": "sidebar", children: _jsx(SidebarContent, {}) }));
});
